export enum StatusUiColorEnum {
  ERROR = "error",
  SUCCESS = "success",
  WARNING = "warning",
  DISABLED = "disabled",
  PURPLE = "purple",
  BLUE = "blue",
  ORANGE = "orange",
}

export type TStatus = StatusUiColorEnum;

export interface IStatusProps {
  text: string;
  status?: TStatus;
  className?: string;
  customBgColor?: string;
  customColor?: string;
}

export interface IStatusStylesObject {
  color: string;
  className: string;
}

export type TStatusStyles = Record<TStatus, IStatusStylesObject>;
